import { useEffect, useMemo } from "react";
import style from "./index.module.less";
import FontSetBox from "@/component/fontSetBox";
import { RightOutline } from "antd-mobile-icons";
import { enhancedSafeChainFind } from "../../../../utils";
import { processOssImage } from "@/utils/image";
interface props {
  list: Array<any>;
  moduleJsonData: any; //样式
  isPeoModel: boolean; // 判断是 个人还是组队模式
  isShowMoreBtn: boolean; // 判断是 是否显示加载更多按钮
  isNotMore: boolean; // 判断是 是否显示 没有更多了
  showNum: number; // 当前显示了多少个用户
  getMore: Function;
  isNewBigRanking?: boolean; // 是否是新大排行榜模式
  onShowFullRanking?: Function; // 显示完整榜单的回调
  isInPopup?: boolean; // 是否在弹窗内
  total?: number; // 总数据数量
}
const App = (props: props) => {
  const {
    list,
    isPeoModel,
    moduleJsonData,
    showNum,
    isShowMoreBtn,
    getMore,
    isNotMore,
    isNewBigRanking = false,
    onShowFullRanking,
    isInPopup = false,
  } = props;
  const getMoreEvent = () => {
    getMore(isPeoModel);
  };

  const showFullRankingEvent = () => {
    if (onShowFullRanking) {
      onShowFullRanking();
    }
  };
  // 样式数据相关的useMemo
  const userNameStyleData = useMemo(() => {
    const result = enhancedSafeChainFind(moduleJsonData.visual)
      ?.prizeSetting("fontSetting")
      ?.content("fontStyle")
      ?.options("userName")?.val?.styleData;
    return (
      result ||
      moduleJsonData?.visual?.prizeSetting?.[3]?.content?.[0]?.options?.[2]?.styleData  
    );
  }, [moduleJsonData]);

  const activityValueStyleData = useMemo(() => {
    const result = enhancedSafeChainFind(moduleJsonData.visual)
      ?.prizeSetting("fontSetting")
      ?.content("fontStyle")
      ?.options("activityValue")?.val?.styleData;
    return (
      result ||
      moduleJsonData?.visual?.prizeSetting?.[3]?.content?.[0]?.options?.[5]?.styleData
    );
  }, [moduleJsonData]);

  const hdFontVal = useMemo(() => {
    const result = enhancedSafeChainFind(moduleJsonData.visual)?.visualData(
      "activityValueName",
    )?.val?.val;
    return result || moduleJsonData?.visual?.visualData?.[3]?.val;
  }, [moduleJsonData]);

  // 在isNewBigRanking模式下，主页面只显示前6个，弹窗显示全部（list是从第四位开始的）
  const displayList = isNewBigRanking && !isInPopup ? list.slice(0, 3) : list;

  return (
    <div
      className={style["Box"]}
      style={{ backgroundColor: isNewBigRanking ? "transparent" : undefined }}
    >
      {isPeoModel &&
        displayList.map((item, index) => (
          <div className={style["listInfoBox"]} key={index}>
            <div>{item.activityRank}</div>
            <div className={style["yuanTX"]}>
              <img src={processOssImage(item.userUrl)} alt="找不到图片" />
            </div>
            <div className={style["infoBox"]}>
              <div className={style["overflowFont"]}>
                <FontSetBox
                  content={item?.userName?.replace("何小鹏", "***")}
                  styleData={userNameStyleData}
                />
              </div>
              <FontSetBox
                content={`${hdFontVal}：${item.totalActivityValue}`}
                styleData={activityValueStyleData}
              />
            </div>
          </div>
        ))}
      {!isPeoModel &&
        displayList.map((item, index) => (
          <div className={style["listInfoBox"]} key={index}>
            <div>{item.activityRank}</div>
            <div className={style["tamYuanTXBox"]}>
              {item?.teamUrlList?.map(
                (userUrl: string | undefined, i: number) => (
                  <div
                    className={style["teamYuanTX"]}
                    key={`${userUrl}${i}`}
                    style={{
                      zIndex: i + 1,
                      transform: `translateX(-50%) translateX(${(i - item.teamUrlList.length / 2) * -10}px)`,
                    }}
                  >
                    <img src={processOssImage(userUrl)} alt="找不到图片" />
                  </div>
                ),
              )}
            </div>

            <div className={style["infoBox"]}>
              <div className={style["overflowFont"]}>
                <FontSetBox
                  content={item.teamName.replace("何小鹏", "***")}
                  styleData={userNameStyleData}
                />
              </div>
              <FontSetBox
                content={`${hdFontVal}：${item.totalActivityValue}`}
                styleData={activityValueStyleData}
              />
            </div>
          </div>
        ))}
      {isNewBigRanking && !isInPopup && (
        <div className={style["getMore"]} onClick={showFullRankingEvent}>
          查看完整榜单
          <RightOutline />
        </div>
      )}

      {/* 弹窗内的加载更多按钮（仅isNewBigRanking模式） */}
      {isNewBigRanking && isInPopup && isShowMoreBtn && (
        <div className={style["getMore"]} onClick={getMoreEvent}>
          查看更多排名
          <RightOutline />
        </div>
      )}

      {/* 弹窗内数据全部加载完成 */}
      {isNewBigRanking && isInPopup && isNotMore && (
        <div className={style["getMore"]}>排名已全部加载</div>
      )}
      {/* 普通模式下的加载更多按钮 */}
      {!isNewBigRanking && isShowMoreBtn && (
        <div className={style["getMore"]} onClick={getMoreEvent}>
          {`只显示排名到${showNum}的用户，点击加载更多`}
          <RightOutline />
        </div>
      )}
      {!isNewBigRanking && !isShowMoreBtn && isNotMore && (
        <div className={style["getMore"]}>排名已全部加载</div>
      )}
    </div>
  );
};

export default App;
